import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-verification-status',
  templateUrl: './verification-status.component.pug',
  styleUrls: ['./verification-status.component.scss'],
  standalone: false
})
export class VerificationStatusComponent implements OnInit {
  @Input() icon: 'success' | 'fail' | 'warning' | null = null;
  @Input() colour = '';
  @Input() text:any = '' ;
  @Input() roundedPill = false;
  iconSrc = '';

  filterStatusOptions = [
    { 'label': $localize`Invited`, 'value': 'Invited' },
    { 'label': $localize`In progress`, 'value': 'In progress' },
    { 'label': $localize`Submitted`, 'value': 'Submitted' },
    { 'label': $localize`Verified`, 'value': 'Verified' },
    { 'label': $localize`Declined`, 'value': 'Declined' },
    { 'label': $localize`Expired`, 'value': 'Expired' },
    { 'label': $localize`Completed`, 'value': 'Completed' },
    { 'label': $localize`Requested`, 'value': 'Requested' },
    { 'label': $localize`Deleted`, 'value': 'Deleted' },
    { 'label': $localize`Stopped`, 'value': 'Stopped' }
  ];
  constructor() {
  }

  ngOnInit(): void {
    this.setText()
    if (this.icon) {
      this.setIcon();
    }
  }

  setIcon() {
    switch(this.icon) {
      case 'success':
        this.iconSrc = 'https://assets.xref.com/omni/shared/success_icon.svg';
        break;
      case 'fail':
        this.iconSrc = 'https://assets.xref.com/omni/shared/fail_icon.svg'
        break;
    }
  }
  setText(){
    let text = this.filterStatusOptions.find(status => status.value === this.text)?.label;
    if (text) {
      this.text = text;
    }
  }
}
